export const addEllipsis = (str: string, len: number) => {
  if (str.length <= len) {
    return str
  }
  return `${str.substring(0, len)}...`
}
